import { useState } from 'react';
import { API } from '@gin-betting/core';

import features from 'services/feature-manager';
import { CategorizerItemByOrganizations } from '../../../../types';
import {
    groupCategorizerItemsByOrganizations,
    sortByTopTournaments,
} from '../../../../utils';

interface Input {
    sportItem: API.CategorizerItem;
}

interface Output {
    categorizerItemsByOrganizations:
        | CategorizerItemByOrganizations[]
        | undefined;
    selectedOrganization: CategorizerItemByOrganizations | undefined;
    selectOrganization: (organizationName?: string) => void;
}

const useOrganizationContainer = ({
    sportItem: { children, value },
}: Input): Output => {
    const [activeOrganization, setActiveOrganization] = useState<
        string | undefined
    >();

    const isActiveTopTournaments = features.isActive(
        features.list.CategorizerTopTournaments
    );

    const categorizerItemsByOrganizations = groupCategorizerItemsByOrganizations(
        isActiveTopTournaments ? sortByTopTournaments(children) : children,
        value
    );
    const organization = categorizerItemsByOrganizations.find(
        ({ name }) => activeOrganization === name
    );

    const selectOrganization = (organizationName?: string) => {
        if (typeof organizationName !== 'string') {
            return setActiveOrganization(undefined);
        }

        setActiveOrganization(organizationName);
    };

    return {
        categorizerItemsByOrganizations,
        selectedOrganization: organization,
        selectOrganization,
    };
};

export default useOrganizationContainer;
